import { useContext, useEffect, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import {  FaCaretDown } from "react-icons/fa";
import VideoContext from "../../store/video-context";
var timeoutHover: any;
const VideoBookmark = (props:any) => {
  //Functions definations Starts
  // const convertSecondToHH_MM_SS = (seconds: any) => {
  //   return new Date(seconds * 1000).toISOString().substr(11, 8)
  // }
  const vContext = useContext(VideoContext);
  const [show, setShow] = useState(false)

  useEffect(()=>{
console.log("VB props", props)
// console.log("VB clicked item", vContext.accordionClickedItem)
  // },[vContext.accordionClickedItem])
  },[])

  const hoverHandler = (data: any) =>{
    vContext.setAccordionClickedItemHandler(data);
    // clearTimeout(timeoutHover);
    // timeoutHover = setTimeout(()=>{
    //   vContext.setAccordionClickedItemHandler({});
    // }, 5000)
  }
  const outHandler = () =>{
    vContext.setAccordionClickedItemHandler({});
    // clearTimeout(timeoutHover);
    // timeoutHover = setTimeout(()=>{
    //   vContext.setAccordionClickedItemHandler({});
    // }, 5000)
  }

  return(
  <OverlayTrigger trigger={['hover', 'focus']} placement="top" 
  show={(JSON.stringify(vContext.accordionClickedItem) !== "{}")? (props.data === vContext.accordionClickedItem) ? true :false :false}
   overlay={
    <Popover id="tooltip-helper" className="tooltip-helper video-bookmark-tooltip">
      {/* <Popover.Content>{convertSecondToHH_MM_SS(props.data.time)}</Popover.Content> */}
      {/* <Popover.Content>{props.data.name}</Popover.Content> */}
      <Popover.Content>{props.type !== "questions" ? props.data.name : props.data.desc}</Popover.Content>
    </Popover>}>
    <div className={`video-bookmark`} style={{left : props.position}} >
      <div className={`video-bookmark-pointer ${props.type + '-bookmark'}`}>
        <FaCaretDown size={20} onClick={()=>{ console.log("video-bookmark",props.data); props.seekVideo(props.data.time)}} onMouseOver={()=>hoverHandler(props.data)} onMouseOut={()=>outHandler()} />
      </div>
    </div>
  </OverlayTrigger>
)
};

export default VideoBookmark;
